import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/pro-solid-svg-icons';
import NotificationTemplate from '../../../../alerts/AlertOptions/NotificationTemplate/NotificationTemplate';
import NotificationTemplatePropType from '../../../../../utility/PropTypes/notificationTemplatePropType';
import { connectModalContainerContextToComponent } from '../../../../../contexts/ModalContext/ModalContext';
import { EMAIL_TEMPLATE_TYPE } from '../../../../../utility/AlertNotificationTemplateUtils';
import TemplateKeywordsBox from '../../TemplateKeywordsBox';

// mapping field ids to object keys, old field ids used CustomTemplate es6 class key names
export const templateFieldNameMap = {
  CLEARED_EMAIL_BODY: 'clearedEmailBody',
  CLEARED_EMAIL_SUBJECT: 'clearedEmailSubject',
  CLEARED_SMS_BODY: 'clearedSmsBody',
  TRIGGERED_EMAIL_BODY: 'triggeredEmailBody',
  TRIGGERED_EMAIL_SUBJECT: 'triggeredEmailSubject',
  TRIGGERED_SMS_BODY: 'triggeredSmsBody',
};

function NotificationTemplateForm({
  template,
  onFieldTextChange,
  updateCursorProperties,
  insertKeywordAtCaret,
  templateType,
}) {
  const [isKeywordsExpanded, setIsKeywordsExpanded] = useState(true);

  const toggleKeywordsExpansion = () => {
    setIsKeywordsExpanded(!isKeywordsExpanded);
  };

  const isEmail = templateType === EMAIL_TEMPLATE_TYPE;
  const propMap = {
    triggeredBodyText: isEmail ? template.triggeredEmailBody : template.triggeredSmsBody,
    triggeredSubjectText: isEmail ? template.triggeredEmailSubject : null,
    clearedBodyText: isEmail ? template.clearedEmailBody : template.clearedSmsBody,
    clearedSubjectText: isEmail ? template.clearedEmailSubject : null,
    // eslint-disable-next-line max-len
    triggeredBodyFieldId: isEmail ? templateFieldNameMap.TRIGGERED_EMAIL_BODY : templateFieldNameMap.TRIGGERED_SMS_BODY,
    triggeredSubjectFieldId: isEmail ? templateFieldNameMap.TRIGGERED_EMAIL_SUBJECT : null,
    // eslint-disable-next-line max-len
    clearedBodyFieldId: isEmail ? templateFieldNameMap.CLEARED_EMAIL_BODY : templateFieldNameMap.CLEARED_SMS_BODY,
    clearedSubjectFieldId: isEmail ? templateFieldNameMap.CLEARED_EMAIL_SUBJECT : null,
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col pl-0 my-2">
          <h6>
            Triggered/Outgoing Template
          </h6>
        </div>
        <div className="col d-flex justify-content-end align-items-center">
          <Button
            variant="link"
            onClick={toggleKeywordsExpansion}
            className="p-0 mr-2"
          >
            Expand / Collapse
          </Button>
        </div>
      </div>

      <div className="row ">
        <div className="col d-flex pt-0 mt-0 justify-content-end align-items-center pr-2">
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              cursor: 'pointer',
            }}
            onClick={toggleKeywordsExpansion}
          >
            <FontAwesomeIcon
              icon={isKeywordsExpanded ? faChevronRight : faChevronLeft}
            />
            <span className="ml-2 pr-3">Keywords</span>
          </div>
        </div>
      </div>

      <div className="row">
        <div className={isKeywordsExpanded ? 'col-sm-12 col-md-9' : 'col-12'}>
          <div className="row">
            <div className="col-sm-12">
              <NotificationTemplate
                templateType={templateType}
                bodyTemplateText={propMap.triggeredBodyText}
                subjectTemplateText={propMap.triggeredSubjectText}
                subjectFieldId={propMap.triggeredSubjectFieldId}
                bodyFieldId={propMap.triggeredBodyFieldId}
                onSubjectTextChange={onFieldTextChange}
                onBodyTextChange={onFieldTextChange}
                onSubjectCursorPropertiesUpdate={updateCursorProperties}
                onBodyCursorPropertiesUpdate={updateCursorProperties}
              />
            </div>
          </div>

          <div className="row">
            <div className="col pl-0">
              <h6 className="my-3">Cleared Template</h6>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <NotificationTemplate
                templateType={templateType}
                bodyTemplateText={propMap.clearedBodyText}
                subjectTemplateText={propMap.clearedSubjectText}
                subjectFieldId={propMap.clearedSubjectFieldId}
                bodyFieldId={propMap.clearedBodyFieldId}
                onSubjectTextChange={onFieldTextChange}
                onBodyTextChange={onFieldTextChange}
                onSubjectCursorPropertiesUpdate={updateCursorProperties}
                onBodyCursorPropertiesUpdate={updateCursorProperties}
              />
            </div>
          </div>
        </div>

        {isKeywordsExpanded && (
        <div className="col-md-3 mt-3 pt-2 col-sm-12">
          <div style={{
            position: 'sticky',
            top: '0',
            height: '100%',
            overflowY: 'auto',
            textAlign: 'right',
          }}
          >
            <TemplateKeywordsBox
              handleSetKeyword={insertKeywordAtCaret}
              maxHeight="600px"
            />
          </div>
        </div>
        )}
      </div>
    </div>
  );
}

NotificationTemplateForm.propTypes = {
  template: PropTypes.shape(NotificationTemplatePropType).isRequired,
  updateCursorProperties: PropTypes.func.isRequired,
  onFieldTextChange: PropTypes.func.isRequired,
  templateType: PropTypes.string.isRequired,
  insertKeywordAtCaret: PropTypes.func.isRequired,
};
export default connectModalContainerContextToComponent(NotificationTemplateForm);
